import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Check, ShoppingBasket, Scale, Navigation, ScanLine, PiggyBank } from "lucide-react";
import client from "@/lib/api";

const STEPS = [
  { id: "list", label: "Build list", icon: ShoppingBasket },
  { id: "plans", label: "Compare plans", icon: Scale },
  { id: "shop", label: "Shop", icon: Navigation },
  { id: "receipt", label: "Scan receipt", icon: ScanLine },
  { id: "savings", label: "Savings", icon: PiggyBank },
];

export default function FlowSteps({ current = 0, listId, tripId }) {
  const navigate = useNavigate();
  const [activeTrip, setActiveTrip] = useState(tripId || null);

  useEffect(() => {
    if (tripId || !listId) { return; }
    client.get("/trips").then((r) => {
      const t = r.data.find((x) => x.list_id === listId && x.status === "active");
      if (t) setActiveTrip(t.id);
    }).catch(() => {});
  }, [listId, tripId]);

  const routes = {
    list: listId ? `/list/${listId}` : "/list",
    plans: listId ? `/list/${listId}/results` : "/list",
    shop: activeTrip ? `/trip/${activeTrip}` : "/discover",
    receipt: activeTrip ? `/trip/${activeTrip}?checkout=1` : "/receipts",
    savings: "/savings",
  };

  return (
    <div className="bg-white/90 backdrop-blur-md rounded-full pp-shadow p-1.5 pp-fade-up" data-testid="flow-steps">
      <ol className="grid grid-cols-5 gap-1">
        {STEPS.map((s, i) => {
          const done = i < current;
          const active = i === current;
          const Icon = done ? Check : s.icon;
          return (
            <li key={s.id}>
              <button type="button" disabled={active} onClick={() => navigate(routes[s.id])} data-testid={`step-nav-${s.id}`}
                className={`w-full flex items-center justify-center gap-1.5 rounded-full px-2 py-2 text-xs font-bold transition-colors duration-200
                  ${active ? "bg-pp-forest text-white cursor-default" : done ? "bg-[#EBF7EE] text-pp-forest hover:bg-[#dff0e3]" : "text-pp-muted hover:bg-pp-cream hover:text-pp-text"}`}>
                <Icon className="h-4 w-4 shrink-0" />
                <span className="hidden sm:inline truncate">{s.label}</span>
              </button>
            </li>
          );
        })}
      </ol>
      <p className="sm:hidden text-center text-[11px] font-bold text-pp-forest pt-1 pb-0.5" data-testid="flow-step-label">
        Step {current + 1} of 5 · {STEPS[current].label}
      </p>
    </div>
  );
}
